import { call } from '../../utils/serviceUtils';
import {
  REPORT_PROCESS_INFORMATION_GET,
  } from '../../config/paths';

export function getProcessReport(request) {
  return call.post(REPORT_PROCESS_INFORMATION_GET, request);
}